import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridOffset } from "@insite/mobius/GridContainer";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { css } from "styled-components";

Object.assign(pageContainerStyles, {
    container: {
        css: css`
            > ${GridOffset} {
                width: calc(100% + 30px) !important;
            }
        `,
    },
    promoCodeGridItem: {
        width: 12,
        css: css`
            padding-top: 5px;
        `,
    },
    promoCodeAndCartTotalContainer: {
        css: css`
            position: sticky;
            top: 115px;
            div[class^="WidgetWrapper"] {
                > div > ${GridOffset} {
                    width: calc(100% + 10px) !important;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 0px;
                    `,
                    css`
                        margin-bottom: 0px;
                    `,
                    css`
                        margin-bottom: 30px;
                    `,
                    css`
                        margin-bottom: 30px;
                    `,
                    css`
                        margin-bottom: 30px;
                    `,
                ])}
        `,
    },
});
